var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2674 20.5142L13.0005 20.3454L12.7334 20.5138L6.67106 24.335L6.67016 24.3356C6.30872 24.5645 5.91861 24.5138 5.62629 24.2913C5.33079 24.0665 5.14788 23.6719 5.24913 23.2159C5.24915 23.2159 5.24916 23.2158 5.24918 23.2157L6.85601 16.0014L6.91922 15.7176L6.70381 15.5222L1.34268 10.6616L1.3425 10.6614C0.657775 10.0412 1.07147 8.92277 1.88096 8.8554L1.88096 8.8554L1.88373 8.85516L8.93939 8.22847L9.24358 8.20145L9.35844 7.91848L12.1194 1.11662L12.1201 1.11473C12.4489 0.295091 13.5511 0.295091 13.8799 1.11473L13.8805 1.11626L16.6414 7.93341L16.7561 8.21671L17.0606 8.24376L24.1163 8.87045L24.119 8.87068C24.9285 8.93806 25.3422 10.0565 24.6575 10.6767L24.6573 10.6769L19.2962 15.5375L19.0808 15.7328L19.144 16.0167L20.7508 23.231C20.8522 23.687 20.6693 24.0817 20.3737 24.3066C20.0814 24.5291 19.6913 24.5798 19.3298 24.3509L19.3297 24.3508L13.2674 20.5142Z",
    fill: "#EBC12B",
    stroke: "#EBC12B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.74e1cd6e57490d9794faddd0c03253f9.svg";
export { ForwardRef as ReactComponent };